import { makeDynamicDataLoader } from './factory';

var _makeDynamicDataLoade = makeDynamicDataLoader('timezones', function (set, client) {
  return client.venues.getVenueTimezones().then(function (data) {
    return set(data.timezones);
  });
}),
    getTimezones = _makeDynamicDataLoade.get,
    loadTimezones = _makeDynamicDataLoade.load;

export { getTimezones, loadTimezones };